import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Orders from '../../../OrdersList/index';

export default () => (
  <Switch>
    <Route exact path="/orders" component={Orders} />
  </Switch>
);
